<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{
          path: BACKEND_URL + '/moduletemplates/edit/' + moduletemplate.id,
          props: { id: moduletemplate.id }
        }"
        v-if="$can('moduletemplate-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(moduletemplate.id)" v-if="$can('moduletemplate-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  name="moduletemplate.name"
                  v-model="moduletemplate.name"
                  class="required-field"
                  v-validate="'required'"
                  :label="$t('moduletemplates.name')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.price"
                  v-model="moduletemplate.price"
                  :label="$t('moduletemplates.price')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.price_vat"
                  v-model="moduletemplate.price_vat"
                  :label="$t('moduletemplates.price_vat')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.req_hours"
                  v-model="moduletemplate.req_hours"
                  :label="$t('moduletemplates.req_hours')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.req_coursetemplate_id"
                  :value="req_coursetemplate.name"
                  :label="$t('moduletemplates.req_coursetemplate_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.req_module_id"
                  :value="req_module.name"
                  :label="$t('moduletemplates.req_module_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.type"
                  :value="this.$dd_moduletemplate_type(moduletemplate.type)"
                  :label="$t('moduletemplates.type')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.template_type"
                  :value="this.$dd_moduletemplate_template_type(moduletemplate.template_type)"
                  :label="$t('moduletemplates.template_type')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="moduletemplate.is_included"
                  v-model="moduletemplate.is_included"
                  :label="$t('moduletemplates.is_included')"
                  readonly
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="moduletemplate.is_joint"
                  v-model="moduletemplate.is_joint"
                  :label="$t('moduletemplates.is_joint')"
                  readonly
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="moduletemplate.status"
                  :value="this.$dd_module_templates_status(moduletemplate.status)"
                  :label="$t('moduletemplates.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar flat dense color="secondary">
            <v-toolbar-title class="subheading">{{ $t("moduleoptions.title") }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <action-button type="new" small @click="showForm(null, 'moduleoption', moduletemplate.id)" :icon_only="true" />
          </v-app-bar>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex md12>
                <v-data-table
                  :headers="headers"
                  :items="moduleoptions"
                  :items-per-page="moduleoptions.length"
                  :options.sync="pagination"
                  :footer-props="{
                    'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                    'items-per-page-all-text': $t('global.items_per_page_all_text'),
                    'items-per-page-text': $t('global.items_per_page_text'),
                    'page-text': $t('global.page_text')
                  }"
                  :server-items-length="total"
                  :loading="show_loading"
                  :expanded.sync="expanded"
                  :loading-text="$t('global.loading_text')"
                  :no-data-text="$t('global.no_data_text')"
                  :no-results-text="$t('global.no_results_text')"
                  :must-sort="true"
                >
                  <template v-slot:item.coursetemplate_id="{ item }">
                    {{ item.coursetemplate ? item.coursetemplate.name : "" }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <!--<action-button
                                            type="default"
                                            small
                                            :text="$t('moduletemplates.expand_button_view_course_types')"
                                            :icon_only="true"
                                            icon="list_alt"
                                            @click="expanded = [item]"
                                            v-if="!expanded.includes(item)"
                                        />-->

                    <action-button
                      type="default"
                      small
                      :text="$t('moduletemplates.expand_button_view_course_types')"
                      :icon_only="true"
                      icon="list_alt"
                      @click="expanded = []"
                      v-if="expanded.includes(item)"
                    />

                    <action-button type="edit" :icon_only="true" small @click="showForm(item.id, 'moduleoption', moduletemplate.id)" />
                    <action-button type="delete" :icon_only="true" small @click="del_option(item.id)" />
                  </template>

                  <template v-slot:item.expand="{ item }"></template>

                  <!-- Module Option - Course Types -->
                  <!--<template v-slot:expanded-item="{ headers, item }">
                                        <td :colspan="headers.length" class="ct-td">
                                            <v-card>
                                                <v-app-bar flat dense color="white">
                                                    <v-toolbar-title
                                                        class="subheading"
                                                    >{{ $t('coursetypes.title') }}</v-toolbar-title>

                                                    <v-spacer></v-spacer>

                                                    <action-button type="new" small @click="showForm(null, 'moduleoptioncoursetype', item.id)" :icon_only="true"/>
                                                </v-app-bar>
                                                <v-card-text class="pa-4">
                                                    <v-simple-table>
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">{{ $t('moduleoptioncoursetypes.coursetype_id') }}</th>
                                                                    <th class="text-left">{{ $t('moduleoptioncoursetypes.name') }}</th>
                                                                    <th class="text-left">{{ $t('moduleoptioncoursetypes.price') }}</th>
                                                                    <th class="text-end" width="20%">{{ $t('global.actions') }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="coursetype in item.coursetypes" :key="coursetype.id">
                                                                    <td scope="row">{{ coursetype.coursetype.fullname }}</td>
                                                                    <td scope="row">{{ coursetype.name }}</td>
                                                                    <td scope="row">{{ coursetype.price }}</td>
                                                                    <td scope="row" class="text-end">
                                                                        <action-button
                                                                            type="edit"
                                                                            :icon_only="true"
                                                                            small
                                                                            @click="showForm(coursetype.id, 'moduleoptioncoursetype', item.id)"
                                                                        />
                                                                        <action-button
                                                                            type="delete"
                                                                            :icon_only="true"
                                                                            small
                                                                            @click="del_option_ct(coursetype.id)"
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-card-text>
                                            </v-card>
                                        </td>
                                    </template>-->
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-dialog v-model="showDialogForm" persistent max-width="960px">
          <div class="form-modal pa-4">
            <component
              :is="currentLoadedForm.form"
              :id="currentLoadedForm.id"
              :moduletemplate_id="currentLoadedForm.moduletemplate_id"
              :moduleoption_id="currentLoadedForm.moduleoption_id"
              :modal="true"
              @return_modal_form="return_modal_form"
              @return_modal_cancel_form="return_modal_cancel_form"
            ></component>
          </div>
        </v-dialog>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ModuleTemplateView",

  props: ["id"],

  components: {
    "moduleoption-form": () => import("../../moduleoptions/components/Form"),
    "moduleoptioncoursetype-form": () => import("../../moduleoptioncoursetypes/components/Form")
  },

  data() {
    return {
      page_title: "",
      moduletemplate: {},
      req_module: {
        name: ""
      },
      req_coursetemplate: {
        name: ""
      },

      currentFormId: "",
      currentModuleTemplateId: "",
      currentModuleOptionId: "",
      currentForm: "",
      showDialogForm: false,

      expanded: [],

      moduleoptions: [],
      total: 0,
      show_loading: false,
      show_filter: false,
      refresh: false,
      pagination: {
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["id"]
      },
      headers: [
        { text: this.$t("moduleoptions.name"), value: "name" },
        {
          text: this.$t("moduleoptions.coursetemplate_id"),
          value: "coursetemplate_id"
        },
        { text: this.$t("moduleoptions.price"), value: "price" },
        { text: this.$t("moduleoptions.hours"), value: "hours" },
        {
          text: this.$t("global.actions"),
          value: "actions",
          width: "20%",
          align: "end"
        }
      ]
    }
  },

  created() {
    axios
      .get(this.API_URL + "moduletemplate/" + this.id)
      .then((res) => {
        this.moduletemplate = res.data.data
        this.req_coursetemplate = this.moduletemplate.req_coursetemplate ? this.moduletemplate.req_coursetemplate : this.req_coursetemplate
        this.req_module = this.moduletemplate.req_module ? this.moduletemplate.req_module : this.req_module

        this.page_title = this.$t("moduletemplates.view_moduletemplate", {
          name: this.moduletemplate.name
        })

        this.moduleoptions_list()
      })
      .catch((err) => console.log(err))
  },

  computed: {
    currentLoadedForm: function() {
      let form,
        id,
        moduletemplate_id,
        moduleoption_id = null

      if (this.currentForm) {
        this.showDialogForm = true

        id = this.currentFormId
        form = this.currentForm
        moduletemplate_id = this.currentModuleTemplateId
        moduleoption_id = this.currentModuleOptionId
      }

      return {
        id: id,
        form: form,
        moduletemplate_id: moduletemplate_id,
        moduleoption_id: moduleoption_id
      }
    }
  },

  methods: {
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduletemplate/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/moduletemplates")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduleoption/" + id)
            .then((res) => {
              vm.moduleoptions_list()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    del_option_ct(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "moduleoptioncoursetype/" + id)
            .then((res) => {
              vm.moduleoptions_list()
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    showForm(id, type, mid) {
      this.currentFormId = id

      if (type == "moduleoption") this.currentModuleTemplateId = mid
      if (type == "moduleoptioncoursetype") this.currentModuleOptionId = mid

      this.currentForm = type + "-form"
    },
    return_modal_form(data) {
      this.return_modal_cancel_form()
      this.moduleoptions_list()
    },
    return_modal_cancel_form() {
      this.currentForm = ""
      this.currentModuleTemplateId = ""
      this.currentModuleOptionId = ""
      this.showDialogForm = false
    },
    moduleoptions_list() {
      this.show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.pagination
      let query = this.$queryString(this.pagination, {
        moduletemplate_id: this.moduletemplate.id
      })

      axios
        .get(this.API_URL + "moduleoptions" + "?" + query)
        .then((res) => {
          this.moduleoptions = res.data.data
          this.total = res.data.meta.total
          this.refresh = false
          this.show_loading = false

          this.pagination.page = res.data.meta.current_page
          this.pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    }
  }
}
</script>

<style scoped>
.form-modal {
  background: white;
}
.ct-td {
  padding: 14px !important;
  background: var(--v-secondary-base) !important;
}
</style>
